import { countryAlias } from '@lib/config'
import { centerOfMass } from '@turf/turf'
import { isArray, map } from 'lodash-es'

const cfg = {
  [countryAlias.au]: {
    sourceLayer: 'combined_au_suburb_v2',
    url: 'mapbox://mapbox.mapbox-streets-v8,hougarden.au_gnaf_nov_24_16_16,hougarden.combined_au_suburb_v2',
    source: 'source_name_combined_au_suburb_v2'
  },
  [countryAlias.nz]: {
    sourceLayer: 'combined_nz_suburbs_withname',
    url: 'mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2,mapbox.mapbox-bathymetry-v2,hougarden.combined_nz_suburbs_withname',
    source: 'source_name_combined_nz_suburbs_withname'
  }
}

export function getConfig({ currentIds }) {
  const filterProp = 'id'
  const { sourceLayer, url, source: sourceName } = cfg[process.env.NEXT_PUBLIC_COUNTRY] || {}

  const source = { url, type: 'vector' }
  const baseProps = {
    source: sourceName,
    'source-layer': sourceLayer,
  }

  // 用于触发事件用
  const layerAll = {
    ...baseProps,
    type: 'fill',
    id: 'combined-nz-suburbs-withname-click',
    paint: {
      'fill-outline-color': 'transparent',
      'fill-color': 'transparent',
    },
  }
  
  // layer
  const filters = isArray(currentIds)
    ? map(currentIds, (id) => ['!=', ['get', filterProp], id])
    : [['!=', ['get', filterProp], '']]

  const layer = {
    ...baseProps,
    type: 'fill',
    id: 'combined-nz-suburbs-withname',
    filter: ['all', ...filters],
    paint: {
      'fill-outline-color': '#a7a3a0',
      'fill-color': 'rgba(0,0,0,.15)',
    },
  }

  // polygon
  const layerLine = {
    ...baseProps,
    type: 'line',
    id: 'combined-nz-suburbs-withname-line',
    filter: ['==', filterProp, ''],
    paint: {
      'line-color': 'rgba(0,0,0,.8)',
      'line-width': 2,
    },
  }

  return {
    source,
    layerAll,
    layer,
    layerLine,
    sourceLayer,
    url,
    filterProp,
  }
}

export function getFetcher(e) {
  let center = null
  let properties = []

  try {
    center = centerOfMass(e.features[0]).geometry.coordinates
    properties = map(e.features, 'properties')
  } catch(err) { /**/ }

  return {
    center,
    properties
  }
}

export function setMapboxConf(mp, e) {
  const { center } = getFetcher(e)
  center && mp.setCenter(center)
}

export function getFilterConf(operator, features, prop) {
  const filters = []
  const vals = []

  isArray(features) && features.forEach((item) => {
    vals.push(item.properties[prop])
    filters.push([operator, prop, item.properties[prop]])
  })

  return {
    filters,
    vals
  }
}
